import React, { FC } from 'react';
import { Template } from './components/Template/Template';
import s from './TemplatesGrid.scss';
import { templatesGridDataHooks } from './TemplatesGrid.dataHooks';
import { isBlankTemplate } from '../../domain/entities/template';
import { TemplatesCarousel } from '../TemplatesCarousel/TemplatesCarousel';
import cs from 'classnames';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import { TemplatesPageHeading } from '../TemplatesPage/TemplatesPageHeading/TemplatesPageHeading';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSearch } from '../../hooks/useSearch';
import { useSelectedCategory } from '../../hooks/useSelectedCategory';
import { useTemplates } from '../../contexts/TemplatesContext';
import { useCurrentPage } from '../../hooks/useCurrentPage';

export interface TemplatesGridProps {
  heading: string;
}

export const TemplatesGrid: FC<TemplatesGridProps> = ({ heading }) => {
  const { templates, error, loading } = useTemplates();
  const { criteria } = useSearch();
  const numOfTemplatesInViewport = 6;
  const selectedCategory = useSelectedCategory();
  const { t } = useTranslation();
  const page = useCurrentPage();

  const isEmptyResult = !error && !loading && templates.length === 0;

  const showInspirationTemplates =
    selectedCategory?.slug === 'all-templates' && page === 1;

  const pantoneSubtitle =
    selectedCategory?.slug === 'wix-studio-x-pantone'
      ? t('app.new.title.search.pantone.subtitle')
      : undefined;

  return (
    <div>
      <div className={s.headingWrapper}>
        <TemplatesPageHeading
          heading={
            isEmptyResult
              ? t('app.new.title.search.notFound.title', { criteria })
              : heading
          }
          subHeading={
            isEmptyResult
              ? t('app.new.title.search.notFound.subtitle')
              : pantoneSubtitle || undefined
          }
        />
      </div>
      <div
        data-hook={templatesGridDataHooks.templatesGrid()}
        className={cs(s.templates)}
      >
        {templates?.map((template, index) => (
          <Template
            key={template.templateId}
            template={template}
            isLazyLoad={index > numOfTemplatesInViewport}
            index={index}
            className={cs({
              [s.desktopOnly]: isBlankTemplate(template),
            })}
          />
        ))}
        {showInspirationTemplates && (
          <div
            className={s.inspirationalCarousel}
            data-hook={templatesGridDataHooks.inspirationalTemplatesCarousel()}
          >
            <TemplatesCarousel />
          </div>
        )}
      </div>
      {error && <ErrorModal />}
    </div>
  );
};
